export function loadScript(
  src: string,
  checkIfLoaded?: () => boolean,
  async = true
): Promise<void> {
  return new Promise((resolve, reject) => {
    // first try checking if the script is loaded using a given function
    if (typeof checkIfLoaded === 'function') {
      if (checkIfLoaded()) {
        resolve(undefined);
        return;
      }
    }

    // then make sure that this script isn't currently loading
    const loading = document.querySelector(`script[src="${src}"]`);

    if (loading) {
      loading.addEventListener('load', resolve as unknown as EventListener);
      loading.addEventListener('error', reject);
      return;
    }

    // otherwise load the script using a script tag and resolve appropriately

    const script = document.createElement('script');

    script.src = src;
    script.async = async;

    script.onload = resolve as unknown as EventListener;
    script.onerror = reject;

    document.head.appendChild(script);
  });
}
